import { ColumnEditor } from 'LookupEditor/ColumnEditors/Base/ColumnEditor';

export class TypeColumnEditor extends ColumnEditor {
    Show(): void {}

    ToString() {
        return 'Type';
    }
}
